import { Col, Row } from "react-bootstrap";
import AbstractionHeaderComponent from "../../components/AbstractionHeaderComponent";

const HeaderSubComponent = () => {
  return (
    <div>
      <Row className="mb-1">
        <Col className="col-md-12">
          <h1>Abstraction Register</h1>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-12">
          <h5>{"  "}</h5>
        </Col>
      </Row>
    </div>
  );
};

const Header = () => {
  const headerContent = <HeaderSubComponent />;
  return <AbstractionHeaderComponent headerContent={headerContent} />;
};

export default Header;
